// src/components/admin/AddJewellery.js
import React, { useState } from 'react';
import axios from 'axios';

const AddJewellery = () => {
  const [formData, setFormData] = useState({
    name: '',
    category: '',
    type: '',
    price: '',
    weight: '',
    description: '',
    karigar: '',
    tags: '',
    status: 'Available',
    image: null,
  });
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setFormData({
      ...formData,
      [name]: files ? files[0] : value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = new FormData();
    for (const key in formData) {
      if (formData[key]) {
        if (key === 'tags') {
          // If backend expects array, we might need to send multiple entries or JSON string. 
          // Multer handles text fields as strings. Backend usually expects JSON string or array.
          // Since we use Multer, simple key-value might imply comma-separated string if backend handles it, 
          // OR we can send it as is and let backend split it.
          // Customer schema handled "tags: [String]". Mongoose casts comma-separated string to array? 
          // Not automatically.
          // Safe bet: formData.append('tags', formData.tags); 
          // AND Update backend to split it if it receives a string.
          // Actually, let's look at `jewelleryRoutes.js`... it uses `req.body`. 
          // If we send `tags` as "a,b", `req.body.tags` will be "a,b".
          // We should update backend or send properly.
          form.append(key, formData[key]);
        } else {
          form.append(key, formData[key]);
        }
      }
    }

    try {
      const response = await axios.post('/api/jewellery', form, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      setSuccess('Jewellery item added successfully!');
      setError(null);
    } catch (error) {
      console.error('Error adding jewellery item:', error.response.data);
      setError(error.response.data.message || 'Error adding jewellery item');
      setSuccess(null);
    }
  };

  return (
    <div className="add-jewellery-container">
      <h2>Add Jewellery Item</h2>
      {error && <div className="error" style={{ backgroundColor: 'red', color: 'white', padding: '10px' }}>{error}</div>}
      {success && <div className="success" style={{ backgroundColor: 'green', color: 'white', padding: '10px' }}>{success}</div>}
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Name:</label>
          <input type="text" name="name" value={formData.name} onChange={handleChange} required />
        </div>
        <div className="form-group">
          <label>Category:</label>
          <input type="text" name="category" value={formData.category} onChange={handleChange} required />
        </div>
        <div className="form-group">
          <label>Type:</label>
          <select name="type" value={formData.type} onChange={handleChange} required>
            <option value="">Select Type</option>
            <option value="gold">Gold</option>
            <option value="silver">Silver</option>
            <option value="custom">Custom</option>
          </select>
        </div>
        <div className="form-group">
          <label>Price:</label>
          <input type="number" name="price" value={formData.price} onChange={handleChange} required />
        </div>
        <div className="form-group">
          <label>Weight (grams):</label>
          <input type="number" name="weight" value={formData.weight} onChange={handleChange} required />
        </div>
        <div className="form-group">
          <label>Karigar (Source):</label>
          <input type="text" name="karigar" value={formData.karigar} onChange={handleChange} placeholder="e.g. Ramesh Gold Works" />
        </div>
        <div className="form-group">
          <label>Tags (comma separated):</label>
          <input type="text" name="tags" value={formData.tags} onChange={handleChange} placeholder="e.g. Wedding, Daily Wear" />
        </div>
        <div className="form-group">
          <label>Status:</label>
          <select name="status" value={formData.status} onChange={handleChange}>
            <option value="Draft">Draft</option>
            <option value="Available">Available</option>
            <option value="Reserved">Reserved</option>
            <option value="Sold">Sold</option>
            <option value="Hidden">Hidden</option>
          </select>
        </div>
        <div className="form-group">
          <label>Description:</label>
          <textarea name="description" value={formData.description} onChange={handleChange} required></textarea>
        </div>
        <div className="form-group">
          <label>Image (optional):</label>
          <input type="file" name="image" onChange={handleChange} />
        </div>
        <button type="submit">Add Jewellery</button>
      </form>
    </div>
  );
};

export default AddJewellery;
